import { defineComponent, h, PropType } from 'vue';
import { clipping_model_editable, toggle_clipping_edit_model, clipping_on, ToggleClippingEditTooltip } from '..';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import toggle_clipping_edit_svg from '../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/toggle_clipping_edit_model.svg';
import { img } from '@phi/components';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ToggleClippingEditIcon = toggle_clipping_edit_svg;

export const ToggleClippingEdit = defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit model at section view';
        },

        disabled() {
            return (!this.state.loaded || (!clipping_on.value && !clipping_model_editable.value));
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled) return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else toggle_clipping_edit_model();
        }
    },

    render() {
        return h(BarButton, {
            id: 'toggle-clipping-edit-model-button',
            tippy: 'top',
            disabled: this.disabled,
            active: clipping_model_editable.value,
            selected: this.state.tut_stage === 3,
            onClick: this.onClick,
            help: 'toggle_clipping_edit_model',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_clipping_edit_svg, this.alt),
            tooltip: ToggleClippingEditTooltip,
        });
    },
});
